/* src/app/main/annexure/list/annexure-list.component.scss */
/*# sourceMappingURL=annexure-list.component-37N4S4JO.css.map */
